import { render, staticRenderFns } from "./AccountsSpaceSettings.vue?vue&type=template&id=864db198&scoped=true&"
import script from "./AccountsSpaceSettings.vue?vue&type=script&lang=js&"
export * from "./AccountsSpaceSettings.vue?vue&type=script&lang=js&"
import style0 from "./AccountsSpaceSettings.vue?vue&type=style&index=0&id=864db198&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864db198",
  null
  
)

export default component.exports